/**
 * RulesPanel — public entry point for the pipeline Rules & automation panel
 * (SE-5506). Mount once near the pipeline board; open it via
 * `useRulesPanelState().open(boardId)`.
 * @module features/player-kanban/components/organisms/RulesPanel
 */

export { default } from "./RulesPanelContainer";
